import "./StudentCouncil.css";

import Farheen from "../../utils/images/student-council/Farheen.jpeg";
import AamiraImg from "../../utils/images/student-council/Aamira.jpeg";
import HeenaKausar from "../../utils/images/student-council/Heena Kausar.jpeg";
import Jishan from "../../utils/images/student-council/Jishan.jpeg";
import MohammadHuzaifa from "../../utils/images/student-council/Mohammad Huzaifa.jpeg";
import MohmmadHarun from "../../utils/images/student-council/Mohmmad Harun.jpeg";
import studentCounncilImg from "../../utils/images/student-council/student-council.PNG";
import Suraj from "../../utils/images/student-council/Suraj.jpeg";
import TarnnumImg from "../../utils/images/student-council/Tarnnum.jpeg";
import Vibha from "../../utils/images/student-council/Vibha.PNG";

import SeparatorJF from "../../blueprints/separator-line/SeparatorJF";

function StudentCouncil() {
  const councilMembers = [
    {
      // position: "Deputy School Captain",
      name: "Iqraa Student Council (ISC)",
      // className: "Class IX",
      image: studentCounncilImg,
    },
    {
      position: "School Captain",
      name: "Aamira",
      className: "Class XI",
      image: AamiraImg,
    },
    {
      position: "DY School Captain",
      name: "Tarnnum",
      className: "Class IX",
      image: TarnnumImg,
    },

    {
      position: "Sports Captain",
      name: "Mohammad Huzaifa",
      className: "Class IX",
      image: MohammadHuzaifa,
    },
    {
      position: "Cultural Captain",
      name: "Heena Kausar",
      className: "Class XII",
      image: HeenaKausar,
    },
    {
      position: "Prefect",
      name: "Farheen",
      className: "Class IX",
      image: Farheen,
    },
    {
      position: "Prefect",
      name: "Vibha",
      className: "Class XI",
      image: Vibha,
    },

    {
      position: "Prefect",
      name: "Jishan",
      className: "Class VIII",
      image: Jishan,
    },
    {
      position: "Prefect",
      name: "Mohmmad Harun",
      className: "Class IX",
      image: MohmmadHarun,
    },

    {
      position: "Prefect",
      name: "Suraj",
      className: "Class XI",
      image: Suraj,
    },
  ];

  return (
    <section className="student-council-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="council-title">
            Student <span>Council</span>
          </h2>
          <SeparatorJF width="420px" color="#0ea5e9" />

          <p className="council-subtitle">
            Empowering student leaders to inspire, guide and represent the
            school community with responsibility, integrity and excellence.
          </p>
        </div>

        <div className="council-grid">
          {councilMembers.map((member, index) => (
            <div key={index} className="council-card">
              <div className="position-badge">{member.position}</div>

              <div className="image-wrapper">
                <img
                  src={member.image}
                  alt={member.name}
                  className="student-image"
                />
              </div>

              <h4>{member.name}</h4>

              <p className="student-class">{member.className}</p>

              {/* <span className="leadership-tag">Student Leader</span> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StudentCouncil;
